<div [formGroup]="form"
     class="cron-container"
     (click)="onClick()">
    <div class="layout-row">
        <div class="cronRadios flex-25">
            <mat-radio-group>
                <mat-radio-button [checked]="typeIs('Minutely')"
                                  (change)="updateCronType('Minutely')"
                                  [value]="'Minutely'">
                    {{ 'cron_type_minutes' | translate }}
                </mat-radio-button>
                <mat-radio-button [checked]="typeIs('Hourly')"
                                  (change)="updateCronType('Hourly')"
                                  [value]="'Hourly'">
                    {{ 'cron_type_hourly' | translate }}
                </mat-radio-button>
                <mat-radio-button [checked]="typeIs('Daily')"
                                  (change)="updateCronType('Daily')"
                                  [value]="'Daily'">
                    {{ 'cron_type_daily' | translate }}
                </mat-radio-button>
                <mat-radio-button [checked]="typeIs('Weekly')"
                                  (change)="updateCronType('Weekly')"
                                  [value]="'Weekly'">
                    {{ 'cron_type_weekly' | translate }}
                </mat-radio-button>
                <mat-radio-button [checked]="typeIs('Monthly')"
                                  (change)="updateCronType('Monthly')"
                                  [value]="'Monthly'">
                    {{ 'cron_type_monthly' | translate }}
                </mat-radio-button>
                <mat-radio-button [checked]="typeIs('Advanced')"
                                  (change)="updateCronType('Advanced')"
                                  [value]="'Advanced'">
                    {{ 'cron_type_advanced' | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="cron-tabs flex-75">
            <div *ngIf="typeIs('Minutely')">
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before layout-row layout-align-v-center layout-align-h-center flex-25">
                        <mat-icon *ngIf="form.get('minutelyAtMinute')!.hasError('required')"
                                  [title]="'cron_range_warning' | translate: {
                                    min: form.get('minutelyAtMinute')!.getError('range')?.min,
                                    max: form.get('minutelyAtMinute')!.getError('range')?.max
                                  }"
                                  class="warn-icon">warning</mat-icon>
                        <label translate>cron_minutes_every</label>
                    </div>
                    <div class="flex-25">
                        <mat-form-field>
                            <ui-suggest [value]="selectedMinute"
                                        [items]="minutes"
                                        [searchable]="false"
                                        [clearable]="false"
                                        (selected)="onMinuteValueChanged($event)"
                                        direction="up"
                                        formControlName="minutelyAtMinute">
                            </ui-suggest>
                        </mat-form-field>
                    </div>
                    <div class="cron-label--after flex-25">
                        <span translate>cron_minutes_minutes</span>
                    </div>
                </div>
            </div>
            <div *ngIf="typeIs('Hourly')">
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before layout-row layout-align-v-center layout-align-h-center flex-20">
                        <mat-icon *ngIf="form.get('hourlyEveryHours')!.hasError('range')"
                                  [title]="'cron_range_warning' | translate: {
                                    min: form.get('hourlyEveryHours')!.getError('range')?.min,
                                    max: form.get('hourlyEveryHours')!.getError('range')?.max
                                  }"
                                  class="warn-icon">warning</mat-icon>
                        <mat-icon *ngIf="!form.get('hourlyEveryHours')!.hasError('range') &&
                                        form.get('hourlyEveryHours')!.hasError('required')"
                                  [title]="'cron_value_required' | translate"
                                  class="warn-icon">warning</mat-icon>
                        <label [attr.aria-label]="'a11y_cron_every_nth_hour' | translate: {
                                    count: cronHourly.value
                                }"
                               translate
                               for="hourlyEveryHours"
                               class="">cron_hourly_every</label>
                    </div>
                    <div class="flex-20">
                        <mat-form-field>
                            <input #cronHourly
                                   (change)="updateCronType('Hourly')"
                                   matInput
                                   class="cron-input form-control"
                                   type="text"
                                   min="1"
                                   max="23"
                                   uiRestrictInput="^[0-9]+$"
                                   name="hourlyEveryHours"
                                   id="hourlyEveryHours"
                                   formControlName="hourlyEveryHours" />
                        </mat-form-field>
                    </div>
                    <div class="cron-label--after flex-25">
                        <span translate>cron_hourly_hours</span>
                    </div>
                </div>
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before layout-row layout-align-v-center layout-align-h-center flex-20">
                        <mat-icon *ngIf="form.get('hourlyAtMinute')!.hasError('range')"
                                  [title]="'cron_range_warning' | translate: {
                                    min: form.get('hourlyAtMinute')!.getError('range')?.min,
                                    max: form.get('hourlyAtMinute')!.getError('range')?.max
                                  }"
                                  class="warn-icon">warning</mat-icon>
                        <mat-icon *ngIf="!form.get('hourlyAtMinute')!.hasError('range') &&
                                        form.get('hourlyAtMinute')!.hasError('required')"
                                  [title]="'cron_value_required' | translate"
                                  class="warn-icon">warning</mat-icon>
                        <label [attr.aria-label]="'a11y_cron_at_minute' | translate: {
                                    count: hourlyAtMinute.value
                                }"
                               translate
                               for="hourlyAtMinute">cron_hourly_at</label>
                    </div>
                    <div class="flex-20">
                        <mat-form-field>
                            <input #hourlyAtMinute
                                   (change)="updateCronType('Hourly')"
                                   matInput
                                   id="hourlyAtMinute"
                                   class="cron-input form-control col-md-2"
                                   type="text"
                                   min="0"
                                   max="59"
                                   uiRestrictInput="^[0-9]+$"
                                   name="hourlyAtMinute"
                                   formControlName="hourlyAtMinute" />
                        </mat-form-field>
                    </div>
                    <div class="cron-label--after flex-25">
                        <span translate>cron_hourly_minutes</span>
                    </div>
                </div>
            </div>
            <div *ngIf="typeIs('Daily')">
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before layout-row layout-align-v-center layout-align-h-center flex-25">
                        <mat-icon *ngIf="form.get('dailyAtHour')!.hasError('range')"
                                  [title]="'cron_range_warning' | translate: {
                                    min: form.get('dailyAtHour')!.getError('range')?.min,
                                    max: form.get('dailyAtHour')!.getError('range')?.max
                                  }"
                                  class="warn-icon">warning</mat-icon>
                        <mat-icon *ngIf="!form.get('dailyAtHour')!.hasError('range') &&
                                        form.get('dailyAtHour')!.hasError('required')"
                                  [title]="'cron_value_required' | translate"
                                  class="warn-icon">warning</mat-icon>
                        <label [attr.aria-label]="'a11y_cron_every_day_at' | translate: {
                                    count: dailyAtHour.value
                                }"
                               translate
                               for="dailyAtHour">cron_every_day_at</label>
                    </div>
                    <div class="flex-20">
                        <mat-form-field>
                            <input #dailyAtHour
                                   (change)="updateCronType('Daily')"
                                   matInput
                                   id="dailyAtHour"
                                   class="cron-input form-control"
                                   type="text"
                                   uiRestrictInput="^[0-9]+$"
                                   min="0"
                                   max="23"
                                   name="dailyAtHour"
                                   formControlName="dailyAtHour" />
                        </mat-form-field>
                    </div>
                    <div class="cron-label--after flex-20">
                        <span translate>cron_daily_hours</span>
                    </div>
                </div>
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before layout-row layout-align-v-center layout-align-h-center flex-25">
                        <mat-icon *ngIf="form.get('dailyAtMinute')!.hasError('range')"
                                  [title]="'cron_range_warning' | translate: {
                                    min: form.get('dailyAtMinute')!.getError('range')?.min,
                                    max: form.get('dailyAtMinute')!.getError('range')?.max
                                  }"
                                  class="warn-icon">warning</mat-icon>
                        <mat-icon *ngIf="!form.get('dailyAtMinute')!.hasError('range') &&
                                        form.get('dailyAtMinute')!.hasError('required')"
                                  [title]="'cron_value_required' | translate"
                                  class="warn-icon">warning</mat-icon>
                        <label [attr.aria-label]="'a11y_cron_daily_and' | translate: {
                                    count: dailyAtMinute.value
                                }"
                               translate
                               for="dailyAtMinute">cron_daily_and</label>
                    </div>
                    <div class="flex-20">
                        <mat-form-field>
                            <input #dailyAtMinute
                                   (change)="updateCronType('Daily')"
                                   matInput
                                   id="dailyAtMinute"
                                   class="cron-input form-control"
                                   type="text"
                                   uiRestrictInput="^[0-9]+$"
                                   min="0"
                                   max="59"
                                   name="dailyAtMinute"
                                   formControlName="dailyAtMinute" />
                        </mat-form-field>
                    </div>
                    <div class="cron-label--after flex-25">
                        <span translate>cron_daily_minutes</span>
                    </div>
                </div>
            </div>
            <div *ngIf="typeIs('Weekly')">
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <label class="cron-label--before flex-20"
                           style="line-height: normal">
                        <mat-icon *ngIf="form.hasError('weekDay')"
                                  [title]="'cron_at_least_one_day_selected_warning' | translate"
                                  class="warn-icon">warning</mat-icon>
                        {{ 'cron_weekly_every' | translate }}
                    </label>
                    <div class="days-container flex-80">
                        <div class="layout-row layout-align-v-center layout-align-h-center layout-wrap">
                            <div class="flex-33"
                                 *ngFor="let day of days">
                                <mat-checkbox [attr.id]="'weekDay' + day.id"
                                              (change)="onDayChange($event,'Weekly', model.weekly.weekdays,  day)"
                                              [checked]="isWeekdayChecked(model.weekly.weekdays, day)">
                                    {{ day.weekly }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before layout-row layout-align-v-center layout-align-h-center flex-20">
                        <mat-icon *ngIf="form.get('weeklyAtHour')!.hasError('range')"
                                  [title]="'cron_range_warning' | translate: {
                                    min: form.get('weeklyAtHour')!.getError('range')?.min,
                                    max: form.get('weeklyAtHour')!.getError('range')?.max
                                  }"
                                  class="warn-icon">warning</mat-icon>
                        <mat-icon *ngIf="!form.get('weeklyAtHour')!.hasError('range') &&
                                        form.get('weeklyAtHour')!.hasError('required')"
                                  [title]="'cron_value_required' | translate"
                                  class="warn-icon">warning</mat-icon>
                        <label [attr.aria-label]="'a11y_cron_weekly_at' | translate: {
                                        count: weeklyAtHour.value
                                    }"
                               translate
                               for="weeklyAtHour">cron_weekly_at</label>
                    </div>
                    <div class="flex-20">
                        <mat-form-field>
                            <input #weeklyAtHour
                                   (change)="updateCronType('Weekly')"
                                   matInput
                                   id="weeklyAtHour"
                                   class="cron-input form-control"
                                   type="text"
                                   uiRestrictInput="^[0-9]+$"
                                   min="0"
                                   max="23"
                                   name="weeklyAtHour"
                                   formControlName="weeklyAtHour" />
                        </mat-form-field>
                    </div>
                    <div class="cron-label--after flex-25">
                        <span translate>cron_weekly_hours</span>
                    </div>
                </div>
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before layout-row layout-align-v-center layout-align-h-center flex-20">
                        <mat-icon *ngIf="form.get('weeklyAtMinute')!.hasError('range')"
                                  [title]="'cron_range_warning' | translate: {
                                    min: form.get('weeklyAtMinute')!.getError('range')?.min,
                                    max: form.get('weeklyAtMinute')!.getError('range')?.max
                                  }"
                                  class="warn-icon">warning</mat-icon>
                        <mat-icon *ngIf="!form.get('weeklyAtMinute')!.hasError('range') &&
                                        form.get('weeklyAtMinute')!.hasError('required')"
                                  [title]="'cron_value_required' | translate"
                                  class="warn-icon">warning</mat-icon>
                        <label [attr.aria-label]="'a11y_cron_weekly_and' | translate: {
                                    count: weeklyAtMinute.value
                                }"
                               translate
                               for="weeklyAtMinute">cron_weekly_and</label>
                    </div>
                    <div class="flex-20">
                        <mat-form-field>
                            <input #weeklyAtMinute
                                   (change)="updateCronType('Weekly')"
                                   matInput
                                   id="weeklyAtMinute"
                                   class="cron-input form-control"
                                   type="text"
                                   uiRestrictInput="^[0-9]+$"
                                   min="0"
                                   max="59"
                                   name="weeklyAtMinute"
                                   formControlName="weeklyAtMinute" />
                        </mat-form-field>
                    </div>
                    <div class="cron-label--after flex-25">
                        <span translate>cron_weekly_minutes</span>
                    </div>
                </div>
            </div>
            <div *ngIf="typeIs('Monthly')">
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before layout-row layout-align-v-center layout-align-h-center flex-20">
                        <mat-icon *ngIf="form.get('monthlyFrequency')!.hasError('range')"
                                  [title]="'cron_range_warning' | translate: {
                                    min: form.get('monthlyFrequency')!.getError('range')?.min,
                                    max: form.get('monthlyFrequency')!.getError('range')?.max
                                  }"
                                  class="warn-icon">warning</mat-icon>
                        <mat-icon *ngIf="!form.get('monthlyFrequency')!.hasError('range') &&
                                        form.get('monthlyFrequency')!.hasError('required')"
                                  [title]="'cron_value_required' | translate"
                                  class="warn-icon">warning</mat-icon>
                        <label [attr.aria-label]="'a11y_cron_monthly_every' | translate: {
                                    count: monthlyFrequency.value
                                }"
                               translate
                               for="monthlyFrequency">cron_monthly_every</label>
                    </div>
                    <div class="flex-20">
                        <mat-form-field>
                            <input #monthlyFrequency
                                   (change)="updateCronType('Monthly')"
                                   matInput
                                   id="monthlyFrequency"
                                   class="cron-input form-control"
                                   type="text"
                                   uiRestrictInput="^[0-9]+$"
                                   min="1"
                                   max="12"
                                   name="monthlyFrequency"
                                   formControlName="monthlyFrequency" />
                        </mat-form-field>
                    </div>
                    <div class="cron-label--after flex-25">
                        <span translate>cron_monthly_months</span>
                    </div>
                </div>
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <label class="cron-label--before flex-20"
                           style="line-height: normal">
                        <mat-icon *ngIf="form.hasError('weekDay')"
                                  [title]="'cron_one_day_mandatory_warning' | translate"
                                  class="warn-icon">warning</mat-icon>
                        {{ 'cron_monthly_every_dow' | translate }}
                    </label>
                    <div class="days-container flex-80">
                        <div class="layout-row layout-align-v-start layout-align-h-center layout-wrap">
                            <div class="flex-33"
                                 *ngFor="let day of days">
                                <mat-checkbox [attr.id]="'monthDay' + day.id"
                                              (change)="onDayChange($event, 'Monthly', model.monthly.weekdays, day)"
                                              [checked]="isWeekdayChecked(model.monthly.weekdays, day)">
                                    {{ day.monthly }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before layout-row layout-align-v-center layout-align-h-center flex-20">
                        <mat-icon *ngIf="form.get('monthlyAtHour')!.hasError('range')"
                                  [title]="'cron_range_warning' | translate: {
                                    min: form.get('monthlyAtHour')!.getError('range')?.min,
                                    max: form.get('monthlyAtHour')!.getError('range')?.max
                                  }"
                                  class="warn-icon">warning</mat-icon>
                        <mat-icon *ngIf="!form.get('monthlyAtHour')!.hasError('range') &&
                                        form.get('monthlyAtHour')!.hasError('required')"
                                  [title]="'cron_value_required' | translate"
                                  class="warn-icon">warning</mat-icon>
                        <label [attr.aria-label]="'a11y_cron_monthly_at' | translate: {
                                    count: monthlyAtHour.value
                                }"
                               translate
                               for="monthlyAtHour">cron_monthly_at</label>
                    </div>
                    <div class="flex-20">
                        <mat-form-field>
                            <input #monthlyAtHour
                                   (change)="updateCronType('Monthly')"
                                   matInput
                                   id="monthlyAtHour"
                                   class="cron-input form-control"
                                   type="text"
                                   uiRestrictInput="^[0-9]+$"
                                   min="0"
                                   max="23"
                                   name="monthlyAtHour"
                                   formControlName="monthlyAtHour" />
                        </mat-form-field>
                    </div>
                    <div class="cron-label--between layout-row layout-align-v-center layout-align-h-center flex-35"
                         style="width:120px">
                        <span>
                            <span translate>cron_monthly_hours</span>
                            <label [attr.aria-label]="'a11y_cron_monthly_and' | translate: {
                                        count: monthlyAtMinute.value
                                    }"
                                   for="monthlyAtMinute">{{ 'cron_monthly_and' | translate | lowercase }}</label>
                            <mat-icon *ngIf="form.get('monthlyAtMinute')!.hasError('range')"
                                      [title]="'cron_range_warning' | translate: {
                                        min: form.get('monthlyAtMinute')!.getError('range')?.min,
                                        max: form.get('monthlyAtMinute')!.getError('range')?.max
                                      }"
                                      class="warn-icon">warning</mat-icon>
                            <mat-icon *ngIf="!form.get('monthlyAtMinute')!.hasError('range') &&
                                            form.get('monthlyAtMinute')!.hasError('required')"
                                      [title]="'cron_value_required' | translate"
                                      class="warn-icon">warning</mat-icon>
                        </span>
                    </div>
                    <div class="flex-20">
                        <mat-form-field>
                            <input #monthlyAtMinute
                                   (change)="updateCronType('Monthly')"
                                   matInput
                                   id="monthlyAtMinute"
                                   class="cron-input form-control"
                                   type="text"
                                   uiRestrictInput="^[0-9]+$"
                                   min="0"
                                   max="59"
                                   name="monthlyAtMinute"
                                   formControlName="monthlyAtMinute" />
                        </mat-form-field>
                    </div>
                    <div class="cron-label--after flex-25">
                        <span translate>cron_monthly_minutes</span>
                    </div>
                </div>
            </div>
            <div *ngIf="typeIs('Advanced')">
                <div class="layout-row layout-align-v-start layout-align-h-center">
                    <div class="cron-label--before flex-33">
                        <label translate
                               for="advancedCron">cron_cron_expression</label>
                    </div>
                    <div class="flex-40">
                        <mat-form-field>
                            <input matInput
                                   (change)="updateCronType('Advanced')"
                                   id="advancedCron"
                                   class="cron-input form-control"
                                   name="advancedCron"
                                   formControlName="advancedCron" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="timezone-info">
                <label>
                    <em>{{timezone}}</em>
                </label>
            </div>
        </div>
    </div>
</div>
